document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('[name="phone"]')) {
        IMask(
            document.querySelector('[name="phone"]'),
            {
                mask: '+38 (000) 000-00-00',
            }
        )
    }
    if (document.querySelector('[name="email"]')) {
        IMask(
            document.querySelector('[name="email"]'),
            {
                mask: 'r{@}r{.}r[{.}r]',
                blocks: {
                    r: {
                        repeat: Infinity,
                        mask: '*',
                    },
                },
                overwrite: 'shift',
            }
        )
    }

    document.querySelector('.js-send-feedback').onclick = event => {
        event.preventDefault();

        let modalInformation = bootstrap.Modal.getOrCreateInstance(document.querySelector('#modal-information'))

        fetch(document.querySelector('.js-send-feedback').dataset.url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
            body: JSON.stringify({
                _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                username: document.querySelector('input[name="username"]').value,
                email: document.querySelector('input[name="email"]').value,
                phone: `+380${document.querySelector('input[name="phone"]').value.replace(/[() \-]/g, '')}`,
                message: document.querySelector('textarea[name="message"]').value,
                contact: document.querySelector('input[name="contact"]').checked,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success === true) {
                    document.querySelector('input[name="username"]').value = ''
                    document.querySelector('input[name="email"]').value = ''
                    document.querySelector('input[name="phone"]').value = ''
                    document.querySelector('textarea[name="message"]').value = ''
                }
                modalInformation._element.querySelector('.js-modal-body').innerHTML = `${data.message}`
                modalInformation.show()
            })
            .catch((error) => {
                console.error(error);
            })
    }
})